(function () {
  const MAX_KG = 47.5;

  const SEL_WEIGHT = "[data-pr-cart-weight]";
  const SEL_HINT = "[data-pr-cart-weight-hint]";
  const SEL_ALERT = "[data-pr-weight-alert], #prWeightLimitAlert";

  let timer = null;
  let inFlight = false;
  let lastUpdate = 0;

  function getLang() {
    return (document.documentElement.lang || "it").split("-")[0].toLowerCase();
  }

  function formatKg(v) {
    const L = getLang();
    const fixed = (Math.round(v * 100) / 100).toFixed(2);
    const num = L === "it" ? fixed.replace(".", ",") : fixed;
    return num + " kg";
  }

  function getTexts() {
    const L = getLang();

    const TXT = {
      it: {
        label: "Peso totale",
        abroad: "estero",
        note: "Info spedizioni estero • Soglia 47,5kg",
        over: " • Per l’estero superi di ",
        left: " • Per l’estero ti restano ",
        alert: "Attenzione: il limite di 47,5 kg è valido solo per spedizioni all’estero. Se la consegna è in Italia puoi procedere normalmente al pagamento. Per spedizioni UE/Extra UE riduci il peso del carrello"
      },
      en: {
        label: "Total weight",
        abroad: "abroad",
        note: "International shipping info • 47.5kg threshold",
        over: " • For international shipping you exceed by ",
        left: " • For international shipping you have left ",
        alert: "Attention: the 47.5 kg limit applies only to international shipments. If delivery is in Italy, you can proceed normally to checkout. For EU/Non-EU shipping, reduce the cart weight"
      },
      de: {
        label: "Gesamtgewicht",
        abroad: "Ausland",
        note: "Info Auslandsversand • Grenze 47,5kg",
        over: " • Für Auslandsversand überschreitest du um ",
        left: " • Für Auslandsversand übrig: ",
        alert: "Achtung: Die Grenze von 47,5 kg gilt nur für Auslandslieferungen. Bei Lieferung in Italien kannst du normal zur Zahlung fortfahren. Für EU-/Nicht-EU-Versand reduziere das Warenkorbgewicht"
      },
      fr: {
        label: "Poids total",
        abroad: "international",
        note: "Info expéditions internationales • Seuil 47,5kg",
        over: " • Pour l’international vous dépassez de ",
        left: " • Pour l’international il vous reste ",
        alert: "Attention : la limite de 47,5 kg s’applique uniquement aux expéditions internationales. Si la livraison est en Italie, vous pouvez procéder normalement au paiement. Pour les expéditions UE/Hors UE, réduisez le poids du panier"
      },
      es: {
        label: "Peso total",
        abroad: "extranjero",
        note: "Info envíos internacionales • Límite 47,5kg",
        over: " • Para envíos internacionales superas por ",
        left: " • Para envíos internacionales te quedan ",
        alert: "Atención: el límite de 47,5 kg solo se aplica a envíos internacionales. Si la entrega es en Italia, puedes proceder normalmente al pago. Para envíos UE/No UE, reduce el peso del carrito"
      }
    };

    return TXT[L] || TXT.it;
  }

  async function getCart() {
    const r = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!r.ok) throw new Error("cart.js fail");
    return r.json();
  }

  function translateStatic() {
    const t = getTexts();

    document.querySelectorAll(".prCartWeightRow").forEach(row => {
      const label = row.querySelector(".previewCartTotals-label, .cart-total-label");

      if (label) {
        const mini = label.querySelector(".prWeightMini");

        label.innerHTML = "";
        label.appendChild(document.createTextNode(t.label + " "));

        if (mini) {
          mini.textContent = "(" + t.abroad + ")";
          label.appendChild(mini);
        } else {
          const span = document.createElement("span");
          span.className = "prWeightMini";
          span.textContent = "(" + t.abroad + ")";
          label.appendChild(span);
        }
      }

      const note = row.querySelector(".prCartWeightNote");

      if (note) {
        const hint = note.querySelector(SEL_HINT) || document.createElement("span");
        hint.className = "prCartWeightHint";
        hint.setAttribute("data-pr-cart-weight-hint", "");

        note.innerHTML = "";
        note.appendChild(document.createTextNode(t.note));
        note.appendChild(hint);
      }
    });
  }

  function updateWeightNotice(kg) {
    const t = getTexts();
    const overLimit = kg > MAX_KG;

    window.__PR_WEIGHT_OVER_LIMIT__ = false;
    window.__PR_WEIGHT_KG__ = kg;

    document.querySelectorAll(SEL_ALERT).forEach(alertBox => {
      alertBox.textContent = t.alert;
      alertBox.style.display = overLimit ? "block" : "none";
      alertBox.style.background = "#fff4d6";
      alertBox.style.color = "#8a5a00";
      alertBox.style.fontWeight = "700";
      alertBox.style.padding = "12px";
      alertBox.style.margin = "0 0 10px";
      alertBox.style.borderRadius = "8px";
      alertBox.style.textAlign = "center";
    });
  }

  async function update() {
    if (inFlight) return;
    if (!document.querySelector(SEL_WEIGHT)) return;

    const now = Date.now();
    if (now - lastUpdate < 250) return;

    inFlight = true;
    lastUpdate = now;

    try {
      const cart = await getCart();

      const grams = (cart.items || []).reduce(
        (s, it) => s + (Number(it.grams) || 0) * (Number(it.quantity) || 0),
        0
      );

      const kg = grams / 1000;
      const t = getTexts();

      document.querySelectorAll(SEL_WEIGHT).forEach(el => {
        el.textContent = formatKg(kg);
      });

      translateStatic();

      document.querySelectorAll(SEL_HINT).forEach(h => {
        const left = MAX_KG - kg;

        h.textContent =
          left < 0
            ? t.over + formatKg(Math.abs(left))
            : t.left + formatKg(left);

        h.classList.toggle("is-over", left < 0);
      });

      updateWeightNotice(kg);

    } catch (e) {
      window.__PR_WEIGHT_OVER_LIMIT__ = false;
    } finally {
      inFlight = false;
    }
  }

  function schedule(ms = 150) {
    clearTimeout(timer);
    timer = setTimeout(update, ms);
  }

  function softBurstUpdate() {
    schedule(120);
    setTimeout(update, 500);
    setTimeout(update, 1100);
  }

  const oldFetch = window.fetch;

  window.fetch = async function () {
    const input = arguments[0];
    const url = typeof input === "string" ? input : input && input.url ? input.url : "";

    const res = await oldFetch.apply(this, arguments);

    if (
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart/clear")
    ) {
      softBurstUpdate();
    }

    return res;
  };

  const oldOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._prCartUrl = url;
    return oldOpen.apply(this, arguments);
  };

  const oldSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("loadend", function () {
      const url = this._prCartUrl || "";

      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        softBurstUpdate();
      }
    });

    return oldSend.apply(this, arguments);
  };

  document.addEventListener("click", e => {
    if (
      e.target.closest(
        "[data-plus-quantity-cart],[data-minus-quantity-cart],[data-cart-remove],[data-cart-add]"
      )
    ) {
      softBurstUpdate();
    }
  });

  document.addEventListener("change", e => {
    if (e.target && e.target.matches("input[data-cart-quantity]")) {
      softBurstUpdate();
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    softBurstUpdate();
  });

  softBurstUpdate();
})();